import { render } from "./TransManagerReportsTab.vue?vue&type=template&id=b9d85efc&scoped=true"
import script from "./TransManagerReportsTab.vue?vue&type=script&lang=js"
export * from "./TransManagerReportsTab.vue?vue&type=script&lang=js"

import "./TransManagerReportsTab.vue?vue&type=style&index=0&id=b9d85efc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9d85efc"]])

export default __exports__